import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import type { UUID } from "../../../../../utils/uuid";
import { SupabaseBrandKitService } from "../../../../brand-kit/server/brand-kit-service";
import { SupabaseAccountService } from "../../../../generic/server/supabase-account-service";

export function useLogo(): UseSupabaseLoaderState<{
  account_id: UUID;
  name: string;
  logo?: string;
}> {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const [{ data: accountData }, { data: logoData }] = await Promise.all([
      new SupabaseAccountService(supabase).get(account_id),
      new SupabaseBrandKitService(supabase).getDefaultLogo(account_id),
    ]);

    return {
      account_id,
      name: accountData?.name ?? "",
      logo: logoData?.brand_logo?.src ?? undefined,
    };
  }, []);
}
